import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferAttrSelectQuery, OfferAttrSelectVo, OfferTopUpAttrSelectQuery } from './type';

/**
 * game service offer上传时查询当前spu下的属性信息，点击一级查子集
  GET /product/offerManage/getOfferManagerAttrInfo
  接口ID：263628563
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628563
 */
export const getOfferGameSerciceAttrOption = (params: OfferAttrSelectQuery): AxiosPromise<OfferAttrSelectVo[]> => {
  return request({
    url: '/product/offerManage/getOfferManagerAttrInfo',
    method: 'get',
    params
  });
};

export const getOfferGameSerciceTopUpAttrOption = (params: OfferTopUpAttrSelectQuery): AxiosPromise<OfferAttrSelectVo[]> => {
  return request({
    url: '/product/offerManage/getOfferManagerAttrInfoTopUp',
    method: 'get',
    params
  });
};
